import { render, staticRenderFns } from "./voucherP.vue?vue&type=template&id=38643cb0&"
import script from "./voucherP.vue?vue&type=script&lang=js&"
export * from "./voucherP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports